import React, {Fragment} from 'react';
import {PillButton} from "./PillButton";
import {DelayedSearchBar} from "./DelayedSearchBar";

export const CommonListPageHeader = function (props) {
    return (
        <div className={"common-list-page-header " + (props.tabs ? "with-tabs" : "")}>
            <div className="common-list-page-header-content">
                <div className="common-list-page-header-content-left">
                    {(() => {
                        if (props.leftHeaderRenderer) {
                            return props.leftHeaderRenderer();
                        } else if (props.tabs) {
                            let tabsDisplay = [];
                            for (let i = 0; i < props.tabs.length; i++) {
                                let tab = props.tabs[i];
                                tabsDisplay.push(
                                    <div
                                        key={i}
                                        className={"common-list-page-header-tab-container " + (tab.selected ? "selected" : "")}
                                        onClick={tab.onClick}
                                    >
                                        <div className="common-list-page-header-tab">
                                            {tab.title}
                                        </div>
                                    </div>
                                )
                            }
                            return (
                                <Fragment>
                                    <div className="common-list-page-header-tab-left-spacer"></div>
                                    {tabsDisplay}
                                    <div className="common-list-page-header-tab-right-spacer"></div>
                                </Fragment>
                            )
                        } else {
                            return (
                                <div className="common-list-page-header-text">
                                    {props.headerText}
                                </div>
                            )
                        }
                    })()}
                </div>
                <div className="common-list-page-header-content-right">
                    {(() => {
                        if (props.rightHeaderRenderer) {
                            return props.rightHeaderRenderer();
                        } else {
                            return (
                                <Fragment>
                                    <DelayedSearchBar
                                        performSearch={props.performSearch}
                                        value={props.searchText}
                                        placeholder={props.searchPlaceholderText}
                                    />
                                    <PillButton
                                        onClick={props.onClickAddButton}
                                        containerClasses="add-button-container"
                                        buttonClasses="add-button"
                                        leftIconSrc={"/static/images/plus-textcolor.svg"}
                                        buttonText="ADD"
                                    />
                                </Fragment>
                            )
                        }
                    })()}
                </div>
            </div>
        </div>
    )
};
